import { TilesContainer } from 'containers/StructuresContainer/StrucuresContainer.styled';
import styled from 'styled-components';

export const BrandContainer = styled(TilesContainer)`
  margin-bottom: unset;
  overflow: auto;
  height: 68vh;
  margin-top: unset;
`;
